import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'

import {Icon} from '@daedalus/atlas/Icon'
import {
  AnnotationLabel,
  BasicTagWrapper,
  Tag,
  Wrapper
} from '@daedalus/atlas/Tag'
import {BrandCode, BrandMessage} from '@daedalus/core/src/brand/types'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

interface Props {
  /** The main message to be displayed. Defaults to "Private deal" if not supplied. */
  message: BrandMessage | undefined
  /** Value to be displayed as percentage saved. Will only display if larger than 0. */
  savingPercentage?: number
  brandCode: BrandCode
}

const DefaultContainer = styled.div``

const KiwiContainer = styled.div(
  ({theme}) => css`
    ${Wrapper} {
      border-radius: ${theme.layout.radius.rounded}px;
      box-shadow: 0 0 0 1px ${theme.colors.border.neutral.c200};
      ${BasicTagWrapper} {
        border-radius: ${theme.layout.radius.rounded}px;
        box-shadow: none;
      }
    }
    ${BasicTagWrapper} {
      border-radius: ${theme.layout.radius.rounded}px;
      box-shadow: 0 0 0 1px ${theme.colors.border.neutral.c200};
    }
    ${AnnotationLabel} {
      border-radius: 0 ${theme.layout.radius.rounded}px
        ${theme.layout.radius.rounded}px 0;
    }
  `
)

export const PrivateDealTag = ({
  message = {
    id: 'privateDeal',
    defaultMessage: 'Private Deal'
  },
  savingPercentage,
  brandCode
}: Props) => {
  const hasSavings = Boolean(savingPercentage && savingPercentage > 0)
  const annotation = hasSavings ? `-${savingPercentage}%` : undefined
  const brandIsVio = brandCode === 'vio'
  const brandIsKiwi = brandCode === 'kiwi'
  const Container = brandIsKiwi ? KiwiContainer : DefaultContainer
  const dataId = brandIsVio ? 'membershipLabel' : 'privateDealTag'
  return (
    <Container data-id={dataId}>
      <Tag
        variant={brandIsKiwi ? 'neutral' : 'special'}
        iconStart={
          brandIsKiwi ? <Icon name="StarSolid" size="sm" /> : undefined
        }
        annotation={annotation}
      >
        <FormattedMessageWrapper {...message} />
      </Tag>
    </Container>
  )
}
